import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterLink } from '@shared/model/lender-config.model';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

@Component({
  selector: 'arcdx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SharedUiLibraryModule]
})
export class FooterComponent {
  @Input() public footerLinks: FooterLink[];
  /** copyright (string) */
  @Input() public copyright: string;
  /** toggle dark mode */
  @Input() public darkMode: boolean;
}
